const nameSpaceFeatureFlag = '[FEATURE FLAG]';

export const FEATURE_FLAG_SET = `${nameSpaceFeatureFlag} SET`;
